import { Card, Col, Row, Space, Typography } from "antd";
import {
  BankOutlined,
  FolderOpenOutlined,
  QuestionCircleOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import { OLIVEEB_COLORS } from "workspaces/colors";

const { Paragraph, Text } = Typography;

const helpItems = [
  {
    title: "Projects",
    description: "Create projects, organize iterations, and track tasks from planning through validation.",
    icon: <FolderOpenOutlined />,
  },
  {
    title: "Workspaces",
    description: "Use the workspace picker to switch context. Bookmarkable URLs include the selected workspace.",
    icon: <BankOutlined />,
  },
  {
    title: "Testing & Validation",
    description: "Review testable products, features, histories, and validation flow from one place.",
    icon: <ToolOutlined />,
  },
];

const Help = () => (
  <div className="project-page">
    <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3 flex-wrap">
      <WidgetSectionTitle
        icon={<QuestionCircleOutlined />}
        title="Help"
        subtitle="Quick guidance for the main Ovacus workflows"
        className="flex-1"
        titleStyle={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}
        subtitleStyle={{ color: OLIVEEB_COLORS.oliveebGreen }}
      />
    </div>

    <Row gutter={[16, 16]}>
      {helpItems.map((item) => (
        <Col xs={24} md={8} key={item.title}>
          <Card
            style={{
              height: "100%",
              borderRadius: 8,
              borderColor: OLIVEEB_COLORS.oliveebGreenSoft,
            }}
          >
            <Space direction="vertical" size={12}>
              <span
                style={{
                  display: "inline-grid",
                  placeItems: "center",
                  width: 42,
                  height: 42,
                  borderRadius: 8,
                  background: OLIVEEB_COLORS.oliveebGreenSoft,
                  color: OLIVEEB_COLORS.oliveebGreen,
                }}
              >
                {item.icon}
              </span>
              <Text strong style={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}>
                {item.title}
              </Text>
              <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                {item.description}
              </Paragraph>
            </Space>
          </Card>
        </Col>
      ))}
    </Row>
  </div>
);

export default Help;
